import React, { useContext } from 'react';
import { CartContext } from '../Context/CartContext';

function CartTester(props) {
  const [cart, setCart] = useContext(CartContext);

  function updateCart() {
    const updatedCart = { ...cart };
    updatedCart.masterId = 1;
    updatedCart.packageId = 11;
    updatedCart.cabins[0].price = 15000;
    updatedCart.cabins[0].adults = 2;
    setCart(updatedCart);
  }

  return (
    <div title="Cart tester"
      className="bg-blue-500 text-center cursor-pointer"
      onClick={updateCart}>
      Update cart
    </div>
  );
}

export default CartTester;